define('CustomerCategory.OrderWizard.Module.Address', [
    'OrderWizard.Module.Address',
    'CustomerCategory.Utils',
    'underscore'
], function CustomerCategoryOrderWizardModuleAddress(
    OrderWizardModuleAddress,
    CustomerCategoryUtils,
    _
) {
    'use strict';

    _.extend(OrderWizardModuleAddress.prototype, {
        getAddressesToShow: _.wrap(OrderWizardModuleAddress.prototype.getAddressesToShow, function fnGetAddressesToShow(fn) {
            var originalResult = fn.apply(this, _.toArray(arguments).slice(1));
            var shippableAddresses = CustomerCategoryUtils.getShippableAddresses();
            if (shippableAddresses && this.options && this.options.title !== 'Billing Address') {
                shippableAddresses = shippableAddresses.split(',');
                originalResult = _.filter(originalResult, function filter(address) {
                    return shippableAddresses.indexOf(address.get('internalid')) >= 0;
                });
            }
            return originalResult;
        }),

        getContext: _.wrap(OrderWizardModuleAddress.prototype.getContext, function fnGetContext(fn) {
            var originalContext = fn.apply(this, _.toArray(arguments).slice(1));
            originalContext.showAddressList = this.getAddressesToShow().length >= 1;
            return originalContext;
        })
    });
});
